const RETURN_TO_PARAM = 'returnTo'

/**
 * True only for same-origin paths beginning with a single "/".
 * Rejects "//evil.com", "/\\evil" (backslash some browsers normalize to "/"),
 * "https://...", "javascript:...", "data:...", "file://...", "vbscript:...",
 * "mailto:...", null, "", and any non-string.
 */
export function isSafeReturnTo(raw: string | null | undefined): raw is string {
  return (
    typeof raw === 'string' &&
    raw.startsWith('/') &&
    !raw.startsWith('//') &&
    !raw.startsWith('/\\')
  )
}

/**
 * Read and validate the returnTo query parameter from a search string.
 * Returns the path if safe, otherwise the provided fallback.
 */
export function readReturnTo(search: string, fallback: string): string {
  const raw = new URLSearchParams(search).get(RETURN_TO_PARAM)
  return isSafeReturnTo(raw) ? raw : fallback
}

/**
 * Build a redirect target that preserves the current location for post-login resume.
 * Returns just `base` when current path would be a no-op (already at base, root, or
 * already a returnTo URL) — preventing nested ?returnTo=?returnTo= chains.
 */
export function buildReturnToRedirect(
  currentPath: string,
  base: string
): string {
  const isNoop =
    !currentPath ||
    currentPath === '/' ||
    currentPath === base ||
    currentPath.startsWith(`${base}?`) ||
    currentPath.startsWith(`${base}/`) ||
    currentPath.startsWith(`/?${RETURN_TO_PARAM}=`) ||
    currentPath.startsWith(`${base}?${RETURN_TO_PARAM}=`)
  if (isNoop || !isSafeReturnTo(currentPath)) return base
  return `${base}?${RETURN_TO_PARAM}=${encodeURIComponent(currentPath)}`
}
